import { useEffect, useMemo, useState } from 'react';
import { NextSeo } from 'next-seo';

import Footer from '@/components/layouts/Footer';
import Header from '@/components/layouts/Header';
import { useFetchCmsContentByType } from '@/components/modules/Landing/api';
import GetInTouch from '@/components/modules/Landing/GetInTouch';
import { CMS_PAGE_TITLES } from '@/types/entities/cms.entities';

const ContactUsPage = () => {
  const [mounted, setMounted] = useState(false);

  // Avoid SSR/client mismatch for CMS + react-query cached content on marketing pages
  useEffect(() => {
    setMounted(true);
    // Force light mode for contact-us page
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);
  const { data: siteSettingContent } = useFetchCmsContentByType(CMS_PAGE_TITLES.SITESETTING);
  const memoizedSiteSettingContent = useMemo(
    () => siteSettingContent?.cmsPage?.pageData,
    [siteSettingContent]
  );

  return (
    <div className="min-h-screen bg-white">
      {/* NextSeo is deliberately OUTSIDE the `mounted` gate. The gate exists to
          avoid an SSR/client mismatch on CMS + react-query content, but the SEO
          tags are static and depend on none of it — while they sat inside the
          gate they were never server-rendered, so crawlers (which don't run JS)
          saw only the site-wide DefaultSeo and this page shared as generic. */}
      <NextSeo
        title="Contact Us - Get in Touch"
        description="Contact Chat.co for sales inquiries, enterprise solutions, or support. Book a demo to see how AI knowledge agents can transform your organization."
        canonical="https://chat.co/contact-us"
        openGraph={{
          url: 'https://chat.co/contact-us',
          title: 'Contact Chat.co - Book a Demo',
          description: 'Get in touch with our team for demos, enterprise solutions, or support.',
          images: [
            {
              url: 'https://chat.co/images/og-contact.png',
              width: 1200,
              height: 630,
              alt: 'Contact Chat.co team',
            },
          ],
        }}
      />
      {!mounted ? null : (
        <>
          <Header contentData={memoizedSiteSettingContent} />
          <GetInTouch isDarkMode={false} />
          <Footer contentData={memoizedSiteSettingContent} />
        </>
      )}
    </div>
  );
};

export const getServerSideProps = async () => {
  return { props: {} };
};

export default ContactUsPage;
